module.exports = __webpack_public_path__ + "img/banner_m.762257a5.jpg";